import React from 'react';
import classNames from 'classnames';
import { Icon } from 'Components';
import Button from '../Button';
import { ReportActionButtonProps } from './ReportActions.types';
import { DOWNLOAD_LABEL } from './ReportActions.constants';
import styles from './ReportActions.module.scss';

const DownloadButton: React.FC<ReportActionButtonProps> = ({
	onClick,
	disabled,
	className,
	label = DOWNLOAD_LABEL
}) => (
	<Button
		size="small"
		className={classNames(styles.button, className)}
		onClick={onClick}
		disabled={disabled}
	>
		<Icon type="download" role="img" className={styles.icon} />
		{label}
	</Button>
);

export default DownloadButton;
